import React, { useEffect, useState } from 'react'
import HospitalTable from "./Tables/HospitalTable";
import AddHospitalForm from "./Forms/CreateForm";
import AddAdminForm from "./Forms/CreateFormAdmin"; // You'll need to create this component
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify'

const HospitalManagement = () => {
  const [hospitals, setHospitals] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showAdminForm, setShowAdminForm] = useState(false);
  const [editingHospital, setEditingHospital] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastAddedHospitalId, setLastAddedHospitalId] = useState(null);
  const token = sessionStorage.getItem("authToken");
  const [member, setMembers] = useState([]);
  const [editingMember, setEditingMember] = useState(null)

  const fetchHospitals = async (page = 1) => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/hospital/get-hospitals`,
        {
          params: {
            limit: 10,
            page: page,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          }
        }
      );
      if (res.status !== 200) {
        return new Error(res.data.error);
      }
      setHospitals(res.data.hospitals);
      setTotalPages(res.data.totalPages);
      setCurrentPage(res.data.currentPage);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error || "Unexpected error occured...", {"position": "top-center"});
    }
  }

  const handleEdit = (hospital) => {
    setEditingHospital(hospital);
    setShowForm(true);
  };

  const handleAddMember = () => {
    setEditingHospital(null);
    setShowForm(true);
  };

  const deleteHospital = async (hospitalId) => {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_BASE_URL}/hospital/delete/${hospitalId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        }
      });
      if (res.status !== 200) {
        throw new Error(res.data.error);
      }
      setHospitals((prev) => {
        return [...prev.filter((hospital) => hospital._id !== hospitalId)]
      });
      toast.success(res.data.message, { position: "top-center" });

    } catch (error) {
      console.error("Error deleting hospital", error);
      toast.error(error.response.data.error, { position: "top-center" });
    }
  }

  const handleFormSubmit = async (newHospital) => {
    try {
      if (!token) {
        toast.error("No authentication token found", { position: "top-center" });
        return;
      }

      if (editingHospital) {
        // Existing update logic remains the same
        const res = await axios.put(
          `${process.env.REACT_APP_BASE_URL}/hospital/update/${newHospital.get("id")}`,
          newHospital,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            }
          }
        );


        if (res.status !== 200) {
          throw new Error(res.data.error);
        }
        setHospitals((prev) => {
          return prev.map((hospital) => hospital._id === newHospital.get("id") ? res.data.updateHospital : hospital);
        })





        toast.success(res.data.message, { "position": "top-center" });
      } else {
        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/hospital/register`,
          newHospital,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (res.status !== 200) {
          throw new Error(res.data.error);
        }
        console.log("ENdhi aaasfasfasd", res.data.hospitalDetails);
        setLastAddedHospitalId(res.data.hospitalDetails._id)
        setHospitals([...hospitals, res.data.hospitalDetails]);
        toast.success(res.data.message, { "position": "top-center" });
        setShowForm(false);
        setShowAdminForm(true);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error || "An unexpected error occurred...", { "position": "top-center" })
    }
  };


  const handleAdminSubmit = async (newMember) => {
    console.log("data received", newMember)
    try {
      console.log("Admin token: ", token)
      if (editingMember) {
        console.log("Updated data....")
        for (let [key, value] of newMember.entries()) {
          console.log(key, value);
        }

        const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/hospital-members/update/${newMember.get("id")}`, newMember, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          }
        })
        if (res.status !== 200) {
          throw new Error(res.data.error);
        }
        setMembers((prevMembers) =>
          prevMembers.map((member) =>
            member._id === editingMember._id ? { ...member, ...res.data.updatedMember } : member
          )
        );
        toast.success(res.data.message, { "position": "top-center" });
        console.log("updatedMember:     ", res.data.updatedMember);

      } else {

        console.log("Submitting Form...", newMember);

        const res = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/hospital-members/register`,
          newMember,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        console.log("Form Submitted Successfully:", res.data);
        setMembers((prevMembers) => [...prevMembers, newMember]);
      }
      toast.success("Admin added successfully...", {"position": "top-center"});
      setShowForm(false);
      setShowAdminForm(false);
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.error || "An unexpected error occurred...", { "position": "top-center" })
    }
  };
  useEffect(() => {
    fetchHospitals();
  }, []);


  return (
    <div style={{ padding: "20px" }}>
      <ToastContainer />
      {!showForm && !showAdminForm ? (
        <HospitalTable
          hospitals={hospitals}
          onEdit={handleEdit}
          onAdd={handleAddMember}
          onDelete={deleteHospital}
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={fetchHospitals}
        />
      ) : showForm ? (
        <AddHospitalForm
          hospital={editingHospital}
          onSubmit={handleFormSubmit}
          onCancel={() => setShowForm(false)}
        />
      ) : showAdminForm ? (
        <AddAdminForm
          hospitalId={lastAddedHospitalId}
          onSubmit={handleAdminSubmit}
          onCancel={() => setShowAdminForm(false)}

        />
      ) : null}
    </div>
  )
}

export default HospitalManagement